/* eslint-disable react/no-unescaped-entities */

import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, HeadlineXL } from '@sorare/core/src/atoms/typography';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import buildYourCareer from '../assets/build-your-career.webp';
import { ImageSection, Img } from '../ui';

const BuildYourCareerSection = styled(ImageSection)`
  @media ${laptopAndAbove} {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background-image: url(${buildYourCareer});
    aspect-ratio: 3/1;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

const StyledContainer = styled(Vertical).attrs({
  gap: 3,
})`
  left: 0;
  right: 0;
  margin: 0 auto;
  padding: var(--double-unit) var(--quadruple-unit);

  z-index: 5;
  background: radial-gradient(
    circle,
    var(--c-nl-500),
    var(--c-nl-300),
    transparent
  );

  @media ${laptopAndAbove} {
    max-width: 60%;
  }
`;

export const BuildYourCareer = () => {
  const isLaptopAndAbove = useIsLaptop();

  return (
    <>
      {!isLaptopAndAbove && (
        <Img src={buildYourCareer} alt="Build your career at Sorare" />
      )}
      <BuildYourCareerSection vAlignContent="bottom" blackLayer="bottom">
        <StyledContainer>
          <HeadlineXL>Build your career at Sorare</HeadlineXL>
          <BodyM>
            Sorare has offices in Paris and New York City, with a staff of more
            than 120. Our "people" are not only the engine that powers Sorare,
            but proudly represent who we are and why it's so great to work here.
            We have assembled the best of the best in their fields – literally
            dozens of award-winning and/or otherwise leading professionals
            spanning all sectors of the company. We have an amazing, energized
            team moving in lockstep to grow Sorare.
          </BodyM>
        </StyledContainer>
      </BuildYourCareerSection>
    </>
  );
};
